import React from 'react';
import { Select } from 'antd';
import { ArrowLeft } from 'lucide-react';
import { DayStatus } from '../data/types';
import { DAYS_META } from '../data/questionsData';

interface QuizGateScreenProps {
  day: number;
  title: string;
  status: DayStatus;
  totalCount: number;
  dayStatuses: Record<number, DayStatus>;
  daysList?: { day: number; title?: string }[];
  onStartDay: () => void;
  onSelectDay: (day: number) => void;
  onExit: () => void;
}

export const QuizGateScreen: React.FC<QuizGateScreenProps> = ({
  day,
  title,
  status,
  totalCount,
  dayStatuses,
  daysList,
  onStartDay,
  onSelectDay,
  onExit,
}) => {
  const isLocked = status === 'LOCKED';
  const isAvailable = status === 'AVAILABLE';

  const getStatusText = () => {
    if (isLocked) {
      return `Ngày ${day} chưa mở. Hãy hoàn thành Ngày ${day - 1} trước.`;
    }
    return `${totalCount} câu hỏi. Câu trả lời được tự động lưu; bạn có thể dừng và quay lại bất cứ lúc nào trong ngày.`;
  };

  const getBadgeText = () => {
    if (isLocked) return 'Chưa mở';
    if (isAvailable) return 'Sẵn sàng bắt đầu';
    return 'Thông tin';
  };

  return (
    <div className="fc-gate-container">
      <div className="fc-gate-card">
        <div className={`fc-gate-badge ${isLocked ? 'locked' : ''}`}>
          {getBadgeText()}
        </div>

        <h2 className="fc-gate-title">
          Ngày {day} · {title}
        </h2>

        <p className="fc-gate-text">{getStatusText()}</p>

        <div className="fc-gate-actions">
          {isAvailable && (
            <button type="button" className="fc-btn-primary" onClick={onStartDay}>
              Bắt đầu Ngày {day}
            </button>
          )}

          <button type="button" className="fc-btn-secondary" onClick={onExit}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
              <ArrowLeft size={15} /> Quay lại
            </span>
          </button>
        </div>

        {/* Other available days shortcut */}
        <div style={{ marginTop: '14px', paddingTop: '16px', borderTop: '1px solid #EEF1F4' }}>
          <div style={{ fontSize: '12px', color: '#5A6577', marginBottom: '8px', fontWeight: 600 }}>
            Chuyển sang ngày khác:
          </div>
          <Select
            value={day}
            onChange={(val) => onSelectDay(Number(val))}
            style={{ width: 140 }}
            options={(daysList || DAYS_META).map((meta) => {
              const dSt = dayStatuses[meta.day] || 'LOCKED';
              const locked = dSt === 'LOCKED';
              return {
                value: meta.day,
                label: `Ngày ${meta.day}${dSt === 'COMPLETED' ? ' ✓' : ''}`,
                disabled: locked,
              };
            })}
          />
        </div>
      </div>
    </div>
  );
};
